/**
 * Main JavaScript file for Lukfiber theme
 */

// Mobile menu toggle functionality
const menuToggle = document.querySelector('.menu-toggle');
const header = document.querySelector('#masthead');
const body = document.querySelector('body');

if (menuToggle) {
  menuToggle.addEventListener('click', function () {
    header.classList.toggle('active');
    body.classList.toggle('no-scroll');
  });
}

// Header mini cart toggle functionality
const miniCartToggle = document.querySelector('.js-header-cart-toggle');
const miniCart = document.querySelector('#header-mini-cart');
const miniCartCloseButtons = document.querySelectorAll(
  '.js-header-mini-cart-close'
);

const positionMiniCart = () => {
  if (!miniCartToggle) return;
  const rect = miniCartToggle.getBoundingClientRect();
  const top = Math.round(rect.bottom + 8);
  const right = Math.round(window.innerWidth - rect.right);

  // Set on :root so CSS can use the vars regardless of where the mini-cart is in the DOM
  document.documentElement.style.setProperty(
    '--header-mini-cart-top',
    `${top}px`
  );
  document.documentElement.style.setProperty(
    '--header-mini-cart-right',
    `${Math.max(16, right)}px`
  );
};

const handleMiniCartReposition = () => {
  if (!document.body.classList.contains('header-mini-cart-open')) return;
  positionMiniCart();
};

const setMiniCartOpen = (isOpen) => {
  if (!miniCart || !miniCartToggle) return;

  if (isOpen) {
    positionMiniCart();
    document.body.classList.add('header-mini-cart-open');
    miniCart.setAttribute('aria-hidden', 'false');
    miniCartToggle.setAttribute('aria-expanded', 'true');
    window.addEventListener('resize', handleMiniCartReposition);
    window.addEventListener('scroll', handleMiniCartReposition, true);
  } else {
    document.body.classList.remove('header-mini-cart-open');
    miniCart.setAttribute('aria-hidden', 'true');
    miniCartToggle.setAttribute('aria-expanded', 'false');
    window.removeEventListener('resize', handleMiniCartReposition);
    window.removeEventListener('scroll', handleMiniCartReposition, true);
  }
};

if (miniCartToggle && miniCart) {
  miniCartToggle.addEventListener('click', () => setMiniCartOpen(true));
  miniCartCloseButtons.forEach((btn) =>
    btn.addEventListener('click', () => setMiniCartOpen(false))
  );

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setMiniCartOpen(false);
  });
}
